import React from 'react'

import Button from '../Button'
import ConfirmationDialog from '../ConfirmationDialog'

type TDeleteConfirmationDialog = {
  title?: string
  text?: string | null
  buttonText?: string
  onConfirm?: () => void
  children?: React.ReactNode
  confirmText?: string
  cancelText?: string
}

const DeleteConfirmationDialog = (
  props: TDeleteConfirmationDialog,
): React.ReactElement => {
  const {
    title,
    text,
    buttonText,
    onConfirm,
    children,
    confirmText,
    cancelText,
  } = props

  return (
    <ConfirmationDialog
      onConfirm={onConfirm}
      title={title || i18n.t('delete', 'Delete')}
      danger
      deleteText={confirmText || i18n.t('yes_delete', 'Yes, delete')}
      cancelText={cancelText || i18n.t(`cancel_btn`, `Abbrechen`)}
      text={
        text === null
          ? ''
          : text || i18n.t('delete_really', 'Do you really want to delete?')
      }
    >
      {children || (
        <Button danger icon="fas fa-trash">
          {buttonText || i18n.t('delete', 'Delete')}
        </Button>
      )}
    </ConfirmationDialog>
  )
}

export default DeleteConfirmationDialog
